import { VideoProps } from 'features/car/types'
import React, { FC, useEffect, useRef } from 'react'
import { NativeVideo } from 'ui/video/NativeVideo'
import { VideoAPI } from 'ui/video/types'
import { YoutubeVideo } from 'ui/video/YoutubeVideo'

export type Props = VideoProps & {
  isActive: boolean
}

export const VideoSlide: FC<Props> = ({ type, link, isActive }) => {
  const api = useRef<VideoAPI | null>(null)

  useEffect(() => {
    if (api.current) {
      if (!isActive) api.current.pause()
    }
  }, [isActive])

  if (type === 'video') return <NativeVideo link={link} onApiReady={(instance) => (api.current = instance)} />

  if (type === 'youtube_video')
    return (
      <div style={{ paddingBottom: '56.25%', position: 'relative' }}>
        <YoutubeVideo link={link} onApiReady={(instance) => (api.current = instance)} />
      </div>
    )

  return null
}
